import React from 'react';
import axios from 'axios';
import PropTypes from 'prop-types'
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
//containers
import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
//text
import { deactivate } from '../input-text/en/dashboard';
//styles
import './login.styl';
import 'bootstrap/dist/css/bootstrap.css';
//config
const baseUrl = require('Config').baseUrl;

class Deactivate extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      loginToken: '',
      popupText: '',
    }
  }

  componentWillMount = () => {
    const loginToken = localStorage.getItem('token');
    this.setState({ loginToken });
  }

  deactivate = () => {
    this.setState({popupText: 'Just a moment...'});
    const url = `${baseUrl}/users/`;

    axios({
      method: 'DELETE',
      url: url,
      headers: { 'x-logged-user': this.state.loginToken }
    })
    .then((response) => {
      this.setState({popupText: response.data.status});
      localStorage.removeItem('token');
      localStorage.removeItem('name');
      setTimeout(()=>{
        this.context.router.history.push('/');
      }, 1400);
    })
    .catch((err) => {
      this.setState({popupText: err.response.data.status});
    });
  }

  goBack = () => {
    this.setState({popupText: 'Yes!'});
    setTimeout(()=>{
      this.context.router.history.push('/dashboard');
    }, 1200);
  }

  popup = () => {
    return (
      <Tooltip placement="right" className="in" id="tooltip-top">
        <h2>{this.state.popupText}</h2>
      </Tooltip>
    );
  }

  render(){
    return (
      <SimpleContainer color='white' containerClass='padded-container'>
        <div className='hidden-xs col-md-4'></div>
        <div className='col-xs-12 col-md-8 deactivate-dialog-container'>
          <h1 className='login-form-title'>{deactivate._1}</h1>
          <p className='highlight'>{deactivate._2}</p>
          <OverlayTrigger className='form-overlay' trigger={'click'} placement="right" overlay={this.popup()}>
            <button className='btn btn-primary' onClick={this.goBack}>{deactivate._3}</button>
          </OverlayTrigger>
          <OverlayTrigger className='form-overlay' trigger={'click'} placement="right" overlay={this.popup()}>
            <button className='btn btn-danger' onClick={this.deactivate}>{deactivate._4}</button>
          </OverlayTrigger>
          <br/>
        </div>
      </SimpleContainer>
    );
  }
};

Deactivate.contextTypes = {
  router: PropTypes.object.isRequired
}
export default Deactivate;



// WEBPACK FOOTER //
// ./src/routes/Deactivate.js